var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.828 9.59042H5.8192C5.01916 9.76817 4.30372 10.2136 3.79112 10.853C3.27851 11.4925 2.99943 12.2877 3 13.1072V13.8192C3 14.1375 3.12643 14.4427 3.35147 14.6677C3.57652 14.8928 3.88174 15.0192 4.2 15.0192H7.2C7.51826 15.0192 7.82348 14.8928 8.04853 14.6677C8.27357 14.4427 8.4 14.1375 8.4 13.8192C8.4 13.501 8.52643 13.1957 8.75147 12.9707C8.97652 12.7456 9.28174 12.6192 9.6 12.6192H14.4C14.7183 12.6192 15.0235 12.7456 15.2485 12.9707C15.4736 13.1957 15.6 13.501 15.6 13.8192C15.6 14.1375 15.7264 14.4427 15.9515 14.6677C16.1765 14.8928 16.4817 15.0192 16.8 15.0192H19.8C20.1183 15.0192 20.4235 14.8928 20.6485 14.6677C20.8736 14.4427 21 14.1375 21 13.8192V13.1072C21 12.2881 20.7207 11.4934 20.2081 10.8545C19.6956 10.2155 18.9804 9.77048 18.1808 9.59281H18.172C14.0953 8.8032 9.90501 8.80239 5.828 9.59042Z",
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/end-call.ce2811320080efdf032fec797bad2e76.svg";
export { ForwardRef as ReactComponent };